import { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import API from '../../api/api'

class ResendActivationLink extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSuccess: false,
      isPending: false,
    }
    this.handleResendActivationLink = this.handleResendActivationLink.bind(this)
  }

  handleResendActivationLink(e) {
    e.preventDefault()
    const { email, onError } = this.props
    this.setState({ isPending: true, message: '' })
    API.recoverPassword(email)
      .then(() => {
        this.setState({ isPending: false, isSuccess: true })
        setTimeout(() => {
          this.setState({ isSuccess: false })
        }, 2000)
      })
      .catch((err) => {
        this.setState({ isPending: false })
        if (typeof onError !== 'undefined') {
          onError(err)
        }
      })
  }

  render() {
    const { t } = this.props
    return (
      <div className="ctp-resend-link">
        <button
          onClick={this.handleResendActivationLink}
          className={`button button-primary ${this.state.isPending ? 'is-loading' : ''}`}
        >
          {t('organisation:resendActivationLink.button')}
        </button>
        {this.state.isSuccess && (
          <p className="help">{t('organisation:resendActivationLink.sentMessage')}</p>
        )}
      </div>
    )
  }
}

ResendActivationLink.propTypes = {
  email: PropTypes.string.isRequired,
  onError: PropTypes.func,
  t: PropTypes.func.isRequired,
}

export default withTranslation(['organisation'])(ResendActivationLink)
